module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-20-be25e65494328a5217044099c47bed17.jpg";